import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';

import OverviewCard from './OverviewCard';

const ManagementOverview = (props) => {
  const { obsDatasetSummaries, obsLatestData } = props;

  return (
    <Row gutter={[16, 16]}>
      {obsDatasetSummaries?.map((obsDataset) => (
        <Col key={obsDataset.obs_dataset_id} xs={24} md={12} xl={8}>
          <OverviewCard obsDataset={obsDataset} obsLatestData={obsLatestData} />
        </Col>
      ))}
    </Row>
  );
};

ManagementOverview.propTypes = {
  obsDatasetSummaries: PropTypes.arrayOf(PropTypes.object),
  obsLatestData: PropTypes.array,
};

ManagementOverview.defaultProps = {
  obsDatasetSummaries: [],
  obsLatestData: [],
};

export default ManagementOverview;
